/**
 * Page header for the Call Centre console: title and one-line description on the left, the page actions
 * (anchored as "{helpKey}.actions" for tours) and the ? help button on the right.
 */

import type { ReactNode } from 'react';
import { Group, Text, Title } from '@/components/ui';
import { PageHelpButton } from '@/components/help';

interface CallCentrePageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  helpKey: string;
  actions?: ReactNode;
  /** Shown above the title (for example a back link). */
  above?: ReactNode;
  /** Shown under the title (for example status badges). */
  below?: ReactNode;
}

export function CallCentrePageHeader({ title, description, helpKey, actions, above, below }: CallCentrePageHeaderProps) {
  return (
    <Group justify="space-between" wrap="wrap" align="flex-start" gap="sm">
      <div style={{ minWidth: 0, flex: 1 }}>
        {above}
        <Title order={2}>{title}</Title>
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
        {below}
      </div>
      <Group gap="sm" data-help-id={`${helpKey}.actions`} wrap="wrap">
        {actions}
        <PageHelpButton pageKey={helpKey} />
      </Group>
    </Group>
  );
}
